export default __webpack_public_path__ + "static/media/dummy.8a50ae65.png";